<template>

    <span style="cursor:pointer;" v-if="tf" @click="phoneclick(phone)"> {{phoneStar(phone)}} </span>
    <span style="cursor:pointer;" v-else @click="phoneclick(phone)"> {{phone}} </span>

</template>
 
<script>
import workercrmapi from "@/script/api/workercrmapi";
export default {
    props: {
        phone: {
            //  type: [String, Number],
            default: "",
        },
    },
    data() {
        return { tf: true };
    },

    computed: {},
    methods: {
        phoneclick(phone) {
            this.tf = !this.tf;
            let req={phone:phone}
            workercrmapi.$axiosPhoneclick(req);
        },
        phoneStar(num) {
            if (num == null || num == "") {
                return null;
            }
            // if (this.tf) {
            //     this.tf = false;
            //     return num;
            // }
            // this.tf = true;
            return num.substr(0, 3) + "****" + num.substr(7);
        },
    },
};
</script>
 
<style   scoped>
</style>